export default __webpack_public_path__ + "static/summer_containers6-5094172397c023d7b32ed036488b2f04.webp";